module.exports = __webpack_public_path__ + "media/images/icons/next_icon-03f6ce710077f9a2abf8874013ad896a.svg";